import { useState } from "react";

import { BodySmall, Box, Modal, ModalFooter, ModalHeader, type SelectChangeEvent } from "@parspec/pixel";

import SelectOutsideSales from "../SelectOutsideSales";
import { useBulkEditContactsMutation } from "../../Contacts/queries";
import { BulkEditContactRequest } from "../../Contacts/queries/apiTypes";
import { RESET_SELECT_OPTION } from "../constant";

interface BulkEditContactProps {
    selectedContactIds: Array<number>;
    onClose: () => void;
    onSuccess: (message: string, updatedData: BulkEditContactRequest) => void;
};

const sxStyle = {
    subtitle: { lineHeight: '1.25rem' },
};

export default function BulkEditContactModal(props: BulkEditContactProps) {
    const { selectedContactIds, onSuccess, onClose } = props;

    const { mutateAsync: bulkEditContacts, isLoading: isBulkEditing } = useBulkEditContactsMutation();

    const [outsideSalesAgent, setOutsideSalesAgent] = useState<string | number>("");

    const onConfirmBulkEdit = async () => {
        // There's only single field available, user need to fill value to initiate bulk udpate
        if (isBulkEditing || outsideSalesAgent === "") return;
        try {
            const outside_sales_agent = outsideSalesAgent === RESET_SELECT_OPTION.value
                ? null // explicitly send null to backend to reset the value
                : Number(outsideSalesAgent);

            const payload: BulkEditContactRequest = {
                contact_ids: selectedContactIds,
                outside_sales_agent,
            };

            const response = await bulkEditContacts(payload);
            onSuccess(response.data.message, payload);
        } catch (err) { }
    };

    const handleFieldChange = (e: SelectChangeEvent<string | number>) => {
        const { value } = e.target;
        setOutsideSalesAgent(value);
    };

    const header = <ModalHeader title="Bulk Edit - Contact" onClose={onClose} />
    const footer = (
        <ModalFooter
            onReject={onClose}
            onAccept={onConfirmBulkEdit}
            continueButtonLabel="Confirm"
            cancelButtonLabel="Cancel"
            isLoading={isBulkEditing}
            disabled={outsideSalesAgent === ""}
        />
    );

    return (
        <Modal header={header} footer={footer} open borderRadius="6px">
            <Box width={500} flexDirection="column" display="flex" gap="8px">
                <BodySmall color="secondary.main" sx={sxStyle.subtitle}>
                    Details
                </BodySmall>
                <SelectOutsideSales
                    showResetOption
                    name="outsideSalesAgent"
                    value={outsideSalesAgent}
                    onChange={handleFieldChange}
                />
            </Box>
        </Modal>
    );
}